import { Link } from "react-router-dom";
const Logo = ({width=150,height=50}) => {
    return (
        <div className="logo me-4">
            <Link to="/" title="Home">
                <img
                    src="/logo.png"
                    width={width}
                    height={height}
                    alt="Logo"
                />
            </Link>
        </div>
    );
};

export default Logo;